<script>
export default {
  name: "CrmTabBar",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    dataTestPrefix: {
      type: String,
      required: true
    }
  },
  emits: ["change"]
};
</script>

<template>
  <div class="crm-tab-bar" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      :class="['crm-tab-bar__tab', { 'is-active': value == tab.value }]"
      :data-test="`${dataTestPrefix}-${tab.key}`"
      @click="$emit('change', tab.value)"
      :data-lang="tab.key"
    >
      <span>{{ tab.label }}</span>
      <span
        v-if="tab.badge !== undefined && tab.badge !== null"
        class="crm-tab-bar__badge"
        :data-test="`${dataTestPrefix}-${tab.key}-badge`"
      >
        {{ tab.badge }}
      </span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.crm-tab-bar {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid #e5e5e5;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.crm-tab-bar::-webkit-scrollbar {
  display: none;
}

.crm-tab-bar__tab {
  display: inline-flex;
  flex: 1 0 auto;
  height: 48px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 16px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #b3b3b3;
  font-size: var(--font-body-lg);
  font-weight: 700;
  white-space: nowrap;
}

.crm-tab-bar__badge {
  display: inline-flex;
  min-width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--primary-color);
  color: var(--font-button-color);
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.crm-tab-bar__tab.is-active {
  border-bottom-color: var(--primary-color);
  color: var(--primary-color);
}
</style>
